'use client'

import SectionLayout from '@component/layout/section'
import Pagination from '@component/pagination'
import { map, size, slice } from 'lodash-es'
import { useMemo, useState } from 'react'

const pageSize = 4
export default function AgentTestimonials({
  data
}) {

  const { testimonial } = data
  const [pageIdx, setPageIdx] = useState(1)
  const ViewData = useMemo(() => {
    const start = (pageIdx - 1) * pageSize
    return slice(testimonial, start, start + pageSize)
  }, [pageIdx, testimonial])

  function changeHandle(idx) {
    setPageIdx(idx)
  }

  return size(testimonial) > 0 && (
    <SectionLayout title='Testimonials'>
      <div className='space-y-16'>{
        map(ViewData, (item, idx) => (
          <div key={idx} className='p-20 bg-neutral-1 rounded-sm md:p-32'>
            <div className='w-[700px] mx-auto text-sm text-font break-words max-w-full'>
              <span dangerouslySetInnerHTML={{ __html: item.body || '' }}></span>
              {item.person && <span className='ml-10'>- {item.person}</span>}
            </div>
          </div>
        ))
      }</div>
      <Pagination className='mt-24' right pageIndex={pageIdx} pageSize={pageSize} totals={size(testimonial)} onChange={changeHandle}></Pagination>
    </SectionLayout>
  )
}